import React, { FC } from 'react';
import { connect } from 'react-redux';

import OpenComposeButton from '../../components/OpenComposeButton';

import { mapStateToProps } from './redux';
import { Props } from './types';

/**
 * Button that opens compose popup on mobiles
 *
 * @param props                Props passed to component
 * @param props.isDraftChanged Whether the draft has been changed
 * @param props.nodeType       The type of the node
 * @returns                    Button react component
 */
const OpenComposeButtonContainer: FC<Props> = ({
  isDraftChanged,
  nodeType,
}) => {
  if (isDraftChanged) {
    // If draft is changed, do not show the button
    return null;
  }

  return <OpenComposeButton nodeType={nodeType} />;
};

export default connect(mapStateToProps)(OpenComposeButtonContainer);
